import { DialogRef } from '@angular/cdk/dialog';
import { Component } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { ModalFooterComponent } from '../modal-footer/modal-footer.component';
import { ButtonComponent } from '../button/button.component';
import { SvgComponent } from '../svg/svg.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@selfcare/cms';

@Component({
  selector: 'sc-unpaid-invoice-modal',
  imports: [
    ModalComponent,
    ModalFooterComponent,
    ButtonComponent,
    SvgComponent,
    AsyncPipe,
    TranslatePipe,
  ],
  templateUrl: './unpaid-invoice-modal.component.html',
})
export class UnpaidInvoiceModalComponent {
  constructor(private readonly dialogRef: DialogRef<boolean>) {}

  public close(approved: boolean) {
    this.dialogRef.close(approved);
  }
}
